import { Injectable } from "@angular/core"; 
import { Employee } from "@app/_models/employee";
import { MsalService } from '@azure/msal-angular';
import { forkJoin, map, Observable, Subject, tap } from "rxjs";
import { RestService } from "./rest.service";
import { AccountService } from "./account.service";
import { Router } from "@angular/router";

@Injectable({
    providedIn:'root'
})

export class GlobalValues{
isDescriptionDDLCloseOnSelect: boolean = true;
userInGroupList: any;
userEmailId: string | undefined;
userName: string | undefined;
accessToken: any;
itGroup:Employee[]=[];
managementGroup:Employee[]=[];
isMk3ManagementGroup = false;
isMk3ITGroup = false;

constructor(private msalService: MsalService, private restService: RestService, public accountService: AccountService, private router: Router,) {
const accounts = this.msalService.instance.getAllAccounts();
if (accounts.length > 0) {
    this.userInGroupList = accounts[0].idTokenClaims;
    this.userEmailId = accounts[0].username;
    this.userName = accounts[0].name;
} else {
        console.warn('No accounts found');
    }
}

async loadUserRoles(): Promise<void> {
    return new Promise((resolve, reject) => {
      if (this.userEmailId) {
        this.loadGroups(this.userEmailId).subscribe({ complete: resolve, error: reject });
      } else {
        this.accountService.getUserNameSetObservable().subscribe({
          next: userEmailId => {
            if (!userEmailId) return reject('User email is missing');
            this.userEmailId = userEmailId;
            this.loadGroups(userEmailId).subscribe({ complete: resolve, error: reject });
          },
          error: reject
        });
      }
    });
  }
  
  private loadGroups(userEmailId: string): Observable<void> {
    return forkJoin([
      this.restService.getMk3ManagementGroup(),
      this.restService.getMk3ITGroup()
    ]).pipe(
      tap(([emp1, emp2]) => {
        if (emp1 && emp1.length > 0) {
          this.isMk3ManagementGroup = emp1.some(
            emp => emp.email?.toLowerCase() === userEmailId.toLowerCase() || userEmailId.toLowerCase() === "jack.morgan@mk3.com.au"
          );
        }
        if (emp2 && emp2.length > 0) {
          this.isMk3ITGroup = emp2.some(
            emp => emp.email?.toLowerCase() === userEmailId.toLowerCase()
          );
        }
      }),
      map(() => void 0)
    );
  }
  
}